import React from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, Segment } from 'semantic-ui-react';
import { history } from '../../_helpers';

export const Breadcrumbs = () => {
  const location = useLocation();
  const slugs = location.pathname.split('/');

  return (
    <Segment>
      <Grid
        style={{
          top: 0,
          margin: 4,
          padding: 0
        }}
      >
        <span>
          {slugs.map((s, idx) => {
            let url = '';
            for (let i = 1; i <= idx; i++) url = url + '/' + slugs[i];

            return (
              <span key={idx}>
                <span onClick={() => history.push(url)}>{s}</span>
                {idx + 1 < slugs.length ? ' / ' : ''}
              </span>
            );
          })}
        </span>
      </Grid>
    </Segment>
  );
};
